import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=12d659aa&"
import script from "./EditCompany.vue?vue&type=script&lang=js&"
export * from "./EditCompany.vue?vue&type=script&lang=js&"
import style0 from "./EditCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditCompany.vue"
export default component.exports